/* eslint-disable react/no-danger */

'use client'

import React, { useEffect } from 'react'
import { extractScriptSrc } from '@utils/cheerioUtils'
import styles from './mainContent.module.scss'

const AckodriveEmbedHtml = ({ content }) => {
  const data = content?.data?.[0]?.attributes?.htmlContent

  useEffect(() => {
    if (data) {
      const src = extractScriptSrc(data)

      if (src) {
        const script = document.createElement('script')
        script.src = src
        document.body.appendChild(script)

        return () => {
          document.body.removeChild(script)
        }
      }
    }
  }, [data])

  return <div className={styles.htmlBaseContentWrapper} dangerouslySetInnerHTML={{ __html: data }} />
}

export default AckodriveEmbedHtml
